import { gql } from 'apollo-boost';

// This query is intented solely for a local cache read of the global data.  This is not
// a query that is implemented on the back-end.
export const globalDataQuery = gql`
  {
    isPropelAdministrator @client
    permissions @client
    orgInfo @client {
      orgId
      businessId
      divisionId
      config {
        defaultCountry
        defaultCurrency
        defaultDensityUnit
        defaultDimensionUnit
        defaultVolumeUnit
        defaultWeightUnit
        organizationTypeId
        p44AccountGroup
        defaultLocationId
        defaultBolInstructions
        defaultDockOpenTime
        defaultDockCloseTime
      }
    }
    orgRefs @client {
      glCodes
      lcpExceptions
    }
    referenceData @client {
      accessorialServices
      chargeCategories
      equipmentTypes
      freightClasses
      hazMatClasses
      hazMatPackingGroups
      packageTypes
      serviceLevels
      shipmentDirections
      shipmentModes
      shipmentStatuses
      netTerms
    }
    user @client {
      firstName
      lastName
      timeZoneId
    }
  }
`;

export const globalSearch = gql`
  query search($orgId: ID!, $searchText: String!, $limit: Int!) {
    search {
      global(orgId: $orgId, searchText: $searchText, limit: $limit) {
        type
        id
        value
        id
        fieldName
        matches {
          fieldName
        }
      }
    }
  }
`;

// Combined query for initial user info.  Add others here as needed.
export const userInfo = gql`
  query userInfo($id: ID!) {
    userAccess {
      me {
        user {
          id
          firstName
          lastName
          loginEmail
          timeZoneId
          orgUsers {
            id
            orgId
            roleId
          }
        }
      }
    }
    organization {
      byId(id: $id) {
        name
        mainBusiness {
          id
          rootDivision {
            id
          }
        }
        config {
          autoTenderEnabled
          defaultCountry
          defaultCurrency
          defaultDensityUnit
          defaultDimensionUnit
          defaultVolumeUnit
          defaultWeightUnit
          defaultDockOpenTime
          defaultDockCloseTime
          organizationTypeId
          defaultDockOpenTime
          defaultDockCloseTime
          p44AccountGroup
          defaultBolInstructions
          defaultLocationId
          minimumLinearFeetForVltl
          minimumPalletCountForVltl
          minimumWeightInPoundsForVltl
          orgUsersMustAcceptEula
          branding {
            id
            majorLogoUrl
            minorLogoUrl
            navigationColor
            navigationHoverColor
            navigationActiveColor
            frontendPrimaryColor
            frontendPrimaryLightColor
            frontendPrimaryDarkerColor
            frontendSecondaryColor
            frontendSecondaryLightColor
            frontendSecondaryDarkerColor
            productName
            poweredByUrl
            supportPhoneNumber
            supportEmailAddress
          }
          defaultBillingTerms {
            addressInfo {
              address1
              address2
              city
              country
              postalCode
              state
            }
            companyName
            contactInfo {
              email
              firstName
              lastName
              phone
            }
            defaultPaymentTerms
          }
        }
      }
    }
    userAccess {
      permissions(orgId: $id) {
        name
        id
        description
      }
    }
  }
`;

export const defaultBrandingInfo = gql`
  query defaultBranding {
    branding {
      defaultBranding {
        majorLogoUrl
        minorLogoUrl
        navigationColor
        navigationHoverColor
        navigationActiveColor
        frontendPrimaryColor
        frontendPrimaryLightColor
        frontendPrimaryDarkerColor
        frontendSecondaryColor
        frontendSecondaryLightColor
        frontendSecondaryDarkerColor
        productName
        poweredByUrl
        supportPhoneNumber
        supportEmailAddress
      }
    }
  }
`;

export const getSearchBarUpdates = gql`
  query getSearchBarUpdates($orgId: ID!) {
    shipment {
      unassignedFiles(orgId: $orgId) {
        totalCount
      }
    }
    notificationLog {
      unreadNotificationCount(orgId: $orgId)
    }
  }
`;
